export class ConnectionDelegate {
    canvasNeeded: ((...args: any[]) => any) | null = null;
    viewSizeChanged: ((...args: any[]) => any) | null = null;
    credentialsNeeded: ((...args: any[]) => any) | null = null;
    trustChallenge: ((...args: any[]) => any) | null = null;
    willConnect: ((...args: any[]) => any) | null = null;
    didConnect: ((...args: any[]) => any) | null = null;
    willDisconnect: ((...args: any[]) => any) | null = null;
    didDisconnect: ((...args: any[]) => any) | null = null;
    loginCompleted: ((...args: any[]) => any) | null = null;
    connectionHealthStateChanged: ((...args: any[]) => any) | null = null;
    mousePointerChanged: ((...args: any[]) => any) | null = null;
    showDefaultMousePointer: ((...args: any[]) => any) | null = null;
    mousePositionChanged: ((...args: any[]) => any) | null = null;
    multiTouchEnabled: ((...args: any[]) => any) | null = null;
    error: ((...args: any[]) => any) | null = null;
    getRemoteClipboardContent: ((...args: any[]) => any) | null = null;
    clipboardContentRequest: ((...args: any[]) => any) | null = null;
    monitorBounds: ((...args: any[]) => any) | null = null;
    displayDesktopBackground: ((...args: any[]) => any) | null = null;
    setRemoteClipboardFormatsComplete: any;

    // temporario
    getGatewayHostname: any = null;
}
